export const formatOperatorName = (displayName: string | null | undefined): string => {
  const tokens = (displayName ?? '').trim().split(/\s+/).filter(Boolean)
  if (tokens.length < 2) {
    return tokens[0] ?? ''
  }
  const [firstName = '', ...rest] = tokens
  return `${firstName.charAt(0).toUpperCase()}. ${rest.at(-1)}`
}
